export default __webpack_public_path__ + "static/media/04_photo.8c98d7e4.jpg";